import { parseInboundPayload } from '../inbound';
import { booleanParser, createArrayWithBracesParser, encodedStringParser, stringParser } from '../inboundParsers';
import { splitWithBraces, trimBraces } from '../inboundUtils';
function confirmWindowButtonActionParser(str) {
    const decodedString = encodedStringParser(str);
    if (decodedString.startsWith("'")) {
        // Starting with a single quote (') indicates this is an outbound to be sent back verbatim on click.
        return {
            type: 'outbound',
            outbound: decodedString.substring(1)
        };
    }
    else {
        // Raw or unsupported button action.
        return {
            type: 'raw',
            value: decodedString
        };
    }
}
const confirmWindowButtonPartDefinitions = [
    { name: 'label', parser: encodedStringParser },
    { name: 'actions', parser: createArrayWithBracesParser(confirmWindowButtonActionParser) },
    { name: 'closeAfterClick', parser: booleanParser }
];
function confirmWindowButtonParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, confirmWindowButtonPartDefinitions);
}
export const SHOW_CONFIRM_WINDOW_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'confirmationType', parser: stringParser },
        { name: 'title', parser: encodedStringParser },
        { name: 'messageHtml', parser: encodedStringParser },
        { name: 'showCloseButton', parser: booleanParser },
        { name: 'isMessageSelectable', parser: booleanParser },
        { name: 'soundLabel', parser: encodedStringParser },
        { name: 'buttons', parser: createArrayWithBracesParser(confirmWindowButtonParser) }
    ]
};
export function isSupportedConfirmWindowInbound(inbound) {
    const supportedTypePrefixes = ['ready_confirmation', 'sit_confirmation', 'feature_intro_side_bets'];
    return supportedTypePrefixes.some((supportedTypePrefix) => inbound.confirmationType.startsWith(supportedTypePrefix));
}
